import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AutocompleteComponent, ControlledInput, FormGrid, Section } from '../../../shared';
import { getCountries } from '../../../shared/constants/countries.constant';
import { validateOriginOption } from '../../../shared/utils/origins.util';

export const SupportCaseAddressInputs: FC = () => {
    const { t } = useTranslation();

    return (
        <Section title={t('addressLabel')}>
            <FormGrid size={{ xs: 12, sm: 6, lg: 3, xl: 2 }}>
                <ControlledInput name="address.street" label={t('streetLabel')} />
                <ControlledInput name="address.number" label={t('numberLabel')} />
                <ControlledInput name="address.box" label={t('boxLabel')} />

                <ControlledInput name="address.postalCode" label={t('postalCodeLabel')} />
                <ControlledInput name="address.city" label={t('cityLabel')} />
                <AutocompleteComponent
                    name="address.country"
                    label={t('countryLabel')}
                    defaultValue={null}
                    options={getCountries}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) => validateOriginOption(option, value)}
                />
            </FormGrid>
        </Section>
    );
};
